export default __webpack_public_path__ + "static/media/297.84036f52.jpg";